module.exports = __webpack_public_path__ + "static/media/logo-white.b9e0424f.png";